import { render, staticRenderFns } from "./create.vue?vue&type=template&id=300b2254&scoped=true"
import script from "./create.js?vue&type=script&lang=js&external"
export * from "./create.js?vue&type=script&lang=js&external"
import style0 from "./create.scss?vue&type=style&index=0&id=300b2254&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "300b2254",
  null
  
)

export default component.exports